import { useState } from 'react';
import { useAddVrLesson } from 'hooks/useAddVrLesson';
import { useCreateLessonVersion } from 'hooks/useCreateLessonVersion';
import { useUpdateLessonImage } from 'hooks/useUpdateLessonImage';
import { LessonForm } from "components/views/editor/models/LessonForm";

export const useCreateVrLessonWithVersion = () => {
    const { addVrLesson } = useAddVrLesson();
    const { createLessonVersion } = useCreateLessonVersion();
    const { updateLessonImageFromFile } = useUpdateLessonImage();
    const [isCreating, setIsCreating] = useState(false);

    const createVrLessonWithVersion = async (
        lessonFormData: LessonForm,
        currentLanguage: string,
        editor: any
    ): Promise<string | null> => {
        setIsCreating(true);

        try {
            const addLessonResponse = await addVrLesson({
                lessonName: lessonFormData.lessonName,
                tagA: lessonFormData.tagA,
                tagB: lessonFormData.tagB,
                isDraft: lessonFormData.isDraft
            });

            const newLessonId = addLessonResponse?.success && addLessonResponse.data
                ? addLessonResponse.data
                : null;

            if (!newLessonId) return null;

            const nodesData = editor && editor.nodes.length > 0 ? editor.toCustomJSON() : null;
            const createVersionResponse = await createLessonVersion({
                lessonId: newLessonId,
                language: currentLanguage,
                name: lessonFormData.lessonVersionName,
                description: lessonFormData.description,
                maxPoints: lessonFormData.maxPoints,
                shuffleAnswers: lessonFormData.shuffleAnswers,
                jsonConfig: nodesData?.jsonConfig ?? null,
                nodes: nodesData?.nodes ?? null,
                connections: nodesData?.connections ?? null,
                feedback: lessonFormData.feedback
            });

            if (!createVersionResponse?.success) return null;

            if (lessonFormData.image) {
                const imageUpdateSuccess = await updateLessonImageFromFile(
                    newLessonId,
                    lessonFormData.image.file
                );
                if (!imageUpdateSuccess) return null;
            }

            return newLessonId;
        } finally {
            setIsCreating(false);
        }
    };

    return { createVrLessonWithVersion, isCreating };
};
